import { useItemStock } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import { getStockStatusIndicatorColor } from "@coworker/app/src/components/RoomSettings/Molecules/ArticleStock.helper";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./item-stock.module.css";
import React from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";

interface ItemStockProps {
  itemNo: string;
  itemType: string;
}

export const ItemStock = ({ itemNo, itemType }: ItemStockProps) => {
  const {
    data: itemStockInfo,
    isLoading: isLoadingItemStockInfo,
    isError,
  } = useItemStock(itemType, itemNo);

  const { t } = useTranslation();

  const stockStatusVariant = getStockStatusIndicatorColor(
    itemStockInfo?.available,
    itemStockInfo?.elevated
  );

  const elevatedStatus = !itemStockInfo?.elevated
    ? "(0)"
    : `(${itemStockInfo?.elevated})`;

  if (isError) {
    return (
      <FixaText textStyle={"Body.S"} className={styles["error-message-text"]}>
        {t("couldNotLoadDataString")}
      </FixaText>
    );
  }

  return (
    <React.Fragment>
      {isLoadingItemStockInfo && <FixaSkeleton width="100%" height="16px" />}
      {!isLoadingItemStockInfo && itemStockInfo && (
        <FixaStatus
          className={styles["item-stock-container"] || ""}
          label={`${itemStockInfo?.available} ${elevatedStatus}`}
          variant={stockStatusVariant}
          small
        />
      )}
    </React.Fragment>
  );
};
